import { memo } from "react";
import Chip from "@mui/material/Chip";
import Tooltip from "@mui/material/Tooltip";
import RssFeedIcon from "@mui/icons-material/RssFeed";

export interface BatchJobKindBadgeProps {
  /** The kind of job, as a person reads it ("PubMed ingest"). */
  label: string;
  /** The job is a run of a corpus feed, not one a person started. */
  feedManaged?: boolean;
}

/** A batch job's kind as a small outlined badge; a run of a corpus feed also carries the feed icon. */
export const BatchJobKindBadge = memo(function BatchJobKindBadge({
  label,
  feedManaged = false,
}: BatchJobKindBadgeProps) {
  const badge = (
    <Chip
      label={label}
      size="small"
      variant="outlined"
      icon={feedManaged ? <RssFeedIcon /> : undefined}
    />
  );
  return feedManaged ? <Tooltip title="Run of a corpus feed">{badge}</Tooltip> : badge;
});
